//
//
//
//
//
//
//
//
//
//


export default {
    data () {
        return {
            link: `https://cdn.vip-wifi.com/fangchan/img/building/material/verify-list.png?v=${Date.now()}`
        }
    },
    methods: {
        preview (e) {
            this.$wx.previewImage({
                current: e.target.src
            })
        }
    }
}
